import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const removeContentLanguage = api(async function removeContentLanguage({ code }) {
    return mutate(
        gql`
            mutation RemoveContentLanguage($code: String!) {
                removeContentLanguage(code: $code)
            }
        `,
        { code },
        { returns: "removeContentLanguage" }
    )
})
